import styled from "@emotion/styled";
import React from "react";

import transition from "~/utilities/transition";

import { h1, h2, h3, h4 } from "~/styles/typographyStyles";

const Div = styled.div`
    h1 {
        ${h1};
    }

    h2 {
        ${h2};
    }

    h3 {
        ${h3};
    }

    h4 {
        ${h4};
    }

    a {
        ${transition({}, "color")};
        color: ${({ theme }) => theme.palette.darkBlue};

        &:hover,
        &:focus {
            color: ${({ theme }) => theme.palette.lightBlue};
        }
    }

    ul {
        list-style-type: disc;
        list-style-position: inside;
    }

    .aligncenter {
        display: block;
        margin-left: auto;
        margin-right: auto;
    }

    .alignleft {
        float: left;
        margin: 0.5em 1em 0.5em 0;
    }

    .alignright {
        float: right;
        margin: 0.5em 0 0.5em 1em;
    }
`;

const UserContent = ({ children, className }) => (
    <Div {...{ className }}>{children}</Div>
);

export default UserContent;
